const baseURL = "https://ewave.com.vn";
console.log('baseURL: ' + baseURL)
export { baseURL };

